import { render } from "./GeneralRequestM.vue?vue&type=template&id=24b9ea05&scoped=true"
import script from "./GeneralRequestM.vue?vue&type=script&lang=js"
export * from "./GeneralRequestM.vue?vue&type=script&lang=js"

import "./GeneralRequestM.vue?vue&type=style&index=0&id=24b9ea05&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24b9ea05"]])

export default __exports__